import React from 'react';
import styles from './PageHeader.module.css';

const PageHeader = ({ title, description }) => {
  return (
    <div className={styles.pageHeader}>
      <div className="container">
        <h1 className={styles.title}>{title}</h1>
        {description && <p className={styles.description}>{description}</p>}
      </div>
    </div>
  );
};

export default PageHeader;
